import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import MainLayout from './layout/MainLayout';
import HomePage from './pages/HomePage';
import Politics from './pages/Politics';
import AllVideos from './pages/AllVideos';
import FullNewsRead from './pages/FullNewsRead';
import { useEffect } from 'react';
import VideoPlay from './pages/VideoPlay';
import CategoryPage from './pages/Business';
import Epaper from './pages/Epaper';
import Contact from './pages/Contact';
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path='/politics' element={<Politics />} />
            <Route path="/news/:id" element={<FullNewsRead />} />
            <Route path='/allvideos' element={<AllVideos />} />
            <Route path='/videoplay' element={<VideoPlay />} />
            <Route path="/category/:category" element={<CategoryPage />} />
            <Route path="/epaper" element={<Epaper />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
